import client from "apis/config";

export const getNewAccountsRequestApi = async (page = 1, limit = 10) => {
  return await client.get(`dashBoard/accounts?page=${page}&limit=${limit}`);
};

export const updateAuctionActionApi = async (paylaod) => {
  return await client.put(`dashBoard/accounts/action`, paylaod);
};
